import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

/**
 * displays a menu panel with a label (if you want)
 * @param {*} props.label optional label to show above in very small text
 * @param {*} props.children content of the manu panel header
 * @returns 
 */
const MenuPanelHeader = ({ label, children }) => {
    return (
        <TextField
            label={label}
            variant="outlined"
            InputProps={{
                readOnly: true,
                disabled: true,
                startAdornment: (
                    <InputAdornment position="start">
                        {children}
                    </InputAdornment>
                ),
            }}
            InputLabelProps={{
                shrink: true,
            }}
            fullWidth
            sx={{
                '& .MuiOutlinedInput-root': {
                    borderRadius: 0,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderLeft: "none",
                    borderRight: "none",
                }
            }}
        />
    );
};

export default MenuPanelHeader;